<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{title}}</h1>
    <div class="scroll" fxFlex>
        <p [innerHTML]="message | safeHTML"></p>
        <div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap.gt-sm="20px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>College: </form-label>
                    <mat-form-field floatLabel="never">
                        <mat-select [(ngModel)]="SelectedCollege" placeholder="Select College..." (change)="UpdateCollege($event)">
                            <ng-container *ngFor="let col of AvailableColleges">
                                <mat-option *ngIf="col.Active" [value]="col">{{col.CollegeName}}</mat-option>
                            </ng-container>                            
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>Search by text: </form-label>
                    <mat-form-field floatLabel="never" fxFlex>
                        <input matInput type="text" #filter [(ngModel)]="CourseSearch" [matAutocomplete]="auto" aria-label="Course Search Box" />
                    </mat-form-field>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="DisplayFn" (optionSelected)="AutocompleteSelected($event)">
                        <mat-option *ngFor="let course of FilteredCourses" [value]="course">
                            <span>{{course.Prefix}} {{course.Code}} - {{course.Name}}</span>
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap.gt-sm="20px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>Department: </form-label>
                    <mat-form-field floatLabel="never">
                        <mat-select [(ngModel)]="DepartmentChoice" placeholder="Select Department...">
                            <mat-option *ngFor="let dept of Departments" [value]="dept.DepartmentID">{{dept.Department}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="DepartmentChoice != null" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <form-label>Course: </form-label>
                    <mat-form-field floatLabel="never">
                        <mat-select [(ngModel)]="CourseChoice" aria-label="Department Course List" placeholder="Select Course..." (change)="UpdateFilter($event)">
                            <mat-option *ngFor="let course of Departments[DepartmentChoice].Courses" [value]="course">{{course.Prefix}} {{course.Code}} - {{course.Name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>                
            </div>
        </div>
        <div *ngIf="CourseChoice">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                <div fxFlex.gt-sm="40">
                    <div><strong>Prefix: </strong>{{CourseChoice.Prefix}}</div>
                    <div><strong>Code: </strong>{{CourseChoice.Code}}</div>
                    <div><strong>Name: </strong>{{CourseChoice.Name}}</div>
                    <div><strong>Credits: </strong>{{CourseChoice.Credits}}</div>
                </div>
                <div fxFlex.gt-sm="40">
                    <div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column">
                        <div><strong>Prerequisite(s): </strong></div>
                        <div fxFlex>{{CourseChoice.Prerequisites}}</div>
                    </div>
                    <div *ngIf="CourseChoice.Corequisites" fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column">
                        <div><strong>Corequisite(s): </strong></div>
                        <div fxFlex>{{CourseChoice.Corequisites}}</div>
                    </div>
                </div>
            </div>
            <div *ngIf="!CourseChoice.Eligible" class="alert">
                <em>This course is not currently designated as an eligible Polk County Public Schools dual enrollment course in the DELTA System.</em>
            </div>
            <div>
                <div style="margin-top:20px"><strong>Description:</strong></div>
                <div [innerHTML]="CourseChoice.Description | safeHTML"></div>
            </div>
        </div>
    </div>
    <div class="bottomactionbar" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center" fxLayoutGap.lt-md="15px">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
            <button mat-raised-button color="primary" [disabled]="!CourseChoice || CourseChoice.Eligible === true" (click)="OKHandler()">Select Course</button>
        </div>
        <button mat-raised-button color="warn" (click)="CancelHandler()">Cancel</button>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/adoptioncoursesearch/adoptioncoursesearch.dialogcomponent.html